<template>
  <div class="blog">
    <div class="head">
      <v-container fluid>
        <v-row class="pa-0 color-morado">
          <v-col cols="12" md="6" class="pa-0 pl-xl-10">
            <v-img
              :src="
                'https://nncms.actstudio.xyz/' +
                post[0].cover.path
              "
            ></v-img>
          </v-col>
          <v-col cols="12" md="6" class="px-5 pa-sm-10" align-self="center">
            <router-link
              :to="'/blog/' + post[0].url"
              class="non-text-decoration"
            >
              <span class="d-block single-item-size my-4 color-morado"
                >{{ post[0].category.display }}
              </span>
            </router-link>

            <router-link
              :to="'/blog/' + post[0].url"
              class="non-text-decoration"
            >
              <span class="d-block single-item-size my-4 color-morado">
                <!-- {{ formatDate(post[post.length - 1]._created) }} -->
                {{ post[0].fechaPublicacion }}
              </span>
            </router-link>

            <router-link
              :to="'/blog/' + post[0].url"
              class="non-text-decoration"
            >
              <span class="titulos-size bold d-block mb-2 color-morado">{{
                post[0].title
              }}</span>
            </router-link>

            <router-link
              :to="'/blog/' + post[0].url"
              class="non-text-decoration"
            >
              <span class="single-item-size d-block color-morado">{{
                post[0].description
              }}</span>
            </router-link>

            <router-link :to="'/blog/' + post[0].url">
              <template v-if="locale == 'en'">
                <span class="single-item-size d-block mt-8">Read more</span>
              </template>
              <template v-else>
                <span class="single-item-size d-block mt-8">Leer más</span>
              </template>
            </router-link>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <div id="posts-content">
      <v-container>
        <v-row class="d-flex d-sm-none">
          <v-col class="text-center">
            <span class="titulos-size bold color-morado">Categorías</span>
          </v-col>
        </v-row>
        <!-- <v-row>
          <v-col class="text-center px-10 px-sm-5 py-2">
            <div
              class="selectionTab"
              @click="filter = 'Ver'"
              v-bind:class="{ selected: filter == 'Ver' }"
            >
              <template v-if="locale == 'en'">
                <span class="single-item-size">All</span>
              </template>
              <template v-else>
                <span class="single-item-size">Ver todo </span>
              </template>
            </div>
          </v-col>
          <v-col
            v-for="cat in categoria"
            :key="cat"
            class="text-center px-7 px-sm-10 py-2"
          >
            <div
              class="selectionTab"
              @click="filter = cat._id"
              v-bind:class="{ selected: filter == cat._id }"
            >
              <span>{{ cat.title }} </span>
            </div>
          </v-col>
        </v-row> -->
        <v-row class="pb-10">
          <template v-for="(content, cont) in post">
            <template v-if="content.category._id == filter && cont > ((page - 1) * 6) && cont < (page * 6)">
              <v-col
                cols="12"
                sm="6"
                md="4"
                class="color-morado px-1"
                :key="'content-' + cont"
              >
                <router-link
                  :to="'/blog/' + content.url"
                  class="non-text-decoration"
                >
                  <span class="d-block single-item-size my-4 color-morado"
                    >{{ content.category.display }}
                  </span>
                </router-link>

                <router-link
                  :to="'/blog/' + content.url"
                  class="non-text-decoration"
                >
                  <v-img
                    :src="'https://nncms.actstudio.xyz/' + content.cover.path"
                    height="292"
                  ></v-img>
                </router-link>

                <router-link
                  :to="'/blog/' + content.url"
                  class="non-text-decoration"
                >
                  <span class="d-block single-item-size my-4 color-morado">
                    <!-- {{ formatDate(content._created) }} -->
                    {{ content.fechaPublicacion }}
                  </span>
                </router-link>

                <router-link
                  :to="'/blog/' + content.url"
                  class="non-text-decoration"
                >
                  <span class="titulos-size bold d-block mb-6 color-morado">{{
                    content.title
                  }}</span>
                </router-link>
                <router-link
                  :to="'/blog/' + content.url"
                  class="non-text-decoration"
                >
                  <span class="single-item-size d-block color-morado">{{
                    content.description
                  }}</span>
                </router-link>
                <router-link :to="'/blog/' + content.url">
                  <template v-if="locale == 'en'">
                    <span class="single-item-size d-block pt-8">Read more</span>
                  </template>
                  <template v-else>
                    <span class="single-item-size d-block pt-8">Leer más</span>
                  </template>
                </router-link>
              </v-col>
            </template>
            <template v-else-if="filter == 'Ver' && cont > ((page - 1) * 6) && cont <= (page * 6)">
              <v-col
                cols="12"
                sm="6"
                md="4"
                class="color-morado px-5"
                :key="'conten-' + cont"
              >
                <router-link
                  :to="'/blog/' + content.url"
                  class="non-text-decoration"
                >
                  <span class="d-block single-item-size my-4 color-morado"
                    >{{ content.category.display }}
                  </span>
                </router-link>

                <router-link :to="'/blog/' + content.url">
                  <v-img
                    :src="'https://nncms.actstudio.xyz/' + content.cover.path"
                    height="292"
                  ></v-img>
                </router-link>

                <router-link
                  :to="'/blog/' + content.url"
                  class="non-text-decoration"
                >
                  <span class="d-block single-item-size my-4 color-morado">
                    <!-- {{ formatDate(content._created) }} -->
                    {{ content.fechaPublicacion }}
                  </span>
                </router-link>

                <router-link
                  :to="'/blog/' + content.url"
                  class="non-text-decoration"
                >
                  <span class="titulos-size bold d-block mb-6 color-morado">{{
                    content.title
                  }}</span>
                </router-link>

                <router-link
                  :to="'/blog/' + content.url"
                  class="non-text-decoration"
                >
                  <span class="single-item-size d-block color-morado">{{
                    content.description
                  }}</span>
                </router-link>

                <router-link :to="'/blog/' + content.url">
                  <template v-if="locale == 'en'">
                    <span class="single-item-size d-block pt-8">Read more</span>
                  </template>
                  <template v-else>
                    <span class="single-item-size d-block pt-8">Leer más</span>
                  </template>
                </router-link>
              </v-col>
            </template>
          </template>
        </v-row>
        <v-row>
          <v-col>
            <v-pagination
              v-model="page"
              :length="pages"
              circle
              color="#5c27b2"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      post: [],
      categoria: [],
      filter: "Ver",
      page: 1
    };
  },

  mounted: function () {
    if(this.locale == 'en'){
      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/Posts?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            sort: {
              fechaPublicacion: -1
            },
            lang: 'en'
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.post = res.entries));
    }else{

      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/Posts?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            sort: {
              fechaPublicacion: -1
            }
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.post = res.entries));
    }

    fetch(
      "https://nncms.actstudio.xyz/api/collections/get/Categoria?token=8cf7ca41761951fdde0c1e2cfda401",
      {
        method: "post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({}),
      }
    )
      .then((res) => res.json())
      .then((res) => (this.categoria = res.entries));
  },
  watch: {
    page: function () {
      this.$vuetify.goTo('#posts-content')
    },
    locale: function () {
      if(this.locale == 'en'){
        fetch(
          "https://nncms.actstudio.xyz/api/collections/get/Posts?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              sort: {
                fechaPublicacion: -1
              },
              lang: 'en'
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.post = res.entries));
      }else{

        fetch(
          "https://nncms.actstudio.xyz/api/collections/get/Posts?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              sort: {
                fechaPublicacion: -1
              },
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.post = res.entries));
      }
    }
  },
  methods: {
    formatDate: function (date) {
      var a = new Date(date * 1000);
      var months = [
        "Enero",
        "Febrero",
        "Marzo",
        "April",
        "Mayo",
        "Junio",
        "Julio",
        "Augosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Deciembre",
      ];
      var fecha =
        a.getDate() + " " + months[a.getMonth()] + " " + a.getFullYear();
      return fecha;
    },
  },
  computed: {
    locale: function () {
      return this.$i18n.locale;
    },
    pages: function () {
      if(this.post.length > 0){
        return parseInt(this.post.length/6);
      }else{
        return 1
      }
    }
  },
};
</script>